'use strict'

const { section, saving } = require('./sections')

const createAutomation = {
  title: 'Create an automation',
  intro: 'An automation is an action the app can run: an HTTP call, a browser script, an email, a record write, or an incoming webhook. This dialog names the automation and picks that type. The steps are edited on the automation page after it exists.',
  sections: [
    section('Name', [
      'Automation title is the name in the automation list and in form actions and schedules. Unique title is the identifier those actions store. It must start with a letter or an underscore, then letters, digits, and underscores.',
      'The unique title fills from the title until you edit the unique title field. After you edit it, title changes leave it alone. A form action and a schedule keep working only while this identifier stays the same.'
    ]),
    section('Type', [
      'HTTP Request calls a URL. You set the method, the address, headers, query parameters, and a body on the automation page. Named variables in those parts can be filled by a form or a schedule.',
      'Playwright drives a browser through steps: open a page, click, type, select, wait, take a screenshot, and assert that text or an element is there.',
      'Send Email sends a message. Map the recipient, subject, and body from variables when a form should supply them.',
      'Write Records creates, updates, or upserts rows on a spreadsheet. The automation page chooses the sheet, the operation, and which columns are set from variables. Password, image, file, formula, and relationship columns are not written by this type.',
      'Webhook gives this automation an address that an outside system can call. The automation page shows the path. The outside system sends the request. A form does not call a webhook to make it run. The outside system does.',
      'The sentence under the type menu is the short description of the type you have selected. Read it before you confirm. The type is the shape of the editor you get next. Pick the type that matches the work. You can change settings later on the automation page. Changing type later replaces the configuration that belonged to the previous type, so choose carefully.',
      'OK creates the automation and selects it. The automation does nothing until you add its steps and something runs it: a form action, a schedule, a test on the automation page, or an outside call for a webhook.'
    ]),
    saving('OK', 'the new automation')
  ]
}

const deleteAutomation = {
  title: 'Delete an automation',
  intro: 'This dialog removes the automation that is open and its execution history.',
  sections: [
    section('What is removed', [
      'The automation definition is deleted. Past runs and their responses are deleted with it. They are not kept as a separate log.',
      'When a form action or a schedule still points at this automation, the dialog lists those uses. A form line names the form and the page. A schedule line names the task. Deleting the automation does not delete those forms and tasks. The next time they run, the automation is missing and the action fails.',
      'Remove or retarget those uses if the form or the task should keep working. Delete here when the automation itself should go.',
      'Delete confirms the removal. Cancel leaves the automation and its history in place.'
    ]),
    saving('delete', 'the removal of this automation and its history')
  ]
}

module.exports = {
  'create-automation': createAutomation,
  'delete-automation': deleteAutomation
}
